import React, { useEffect } from "react";
import "./GoogleCSE.css";

const GoogleCSE = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://cse.google.com/cse.js?cx=230581f36406547f0";
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <div className="gcse-search" placeholder="Search"></div>;
};

export default GoogleCSE;
